import { useMatches } from 'react-router';

export function useCombinedRouterMatchesHandle<TProps>(
  handleProps?: TProps,
): TProps {
  const matches = useMatches();

  return matches.reduce((acc, match) => {
    const matchHandle = match.handle ?? {};
    const matchLoaderDataHandle =
      match.loaderData &&
      typeof match.loaderData === 'object' &&
      'handle' in match.loaderData &&
      typeof match.loaderData.handle === 'object'
        ? match.loaderData.handle
        : {};

    return { ...acc, ...matchHandle, ...matchLoaderDataHandle };
  }, handleProps ?? {}) as TProps;
}
